export const MAIN_CLASS_NAME = 'project-article-list';
